import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ListRouter from './ListRouter';
import ClientProvider from './client';
export default createDemo(import.meta.url, ListRouter, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/list-router/ListRouter.tsx",
    "fileName": "ListRouter.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport Box from '@mui/material/Box';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport Paper from '@mui/material/Paper';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\nimport Typography from '@mui/material/Typography';\nimport {\n  Link,\n  Route,\n  Routes,\n  MemoryRouter,\n  useLocation,\n  StaticRouter,\n} from 'react-router';\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/drafts\">{children}</StaticRouter>;\n  }\n\n  return (\n    <MemoryRouter initialEntries={['/drafts']} initialIndex={0}>\n      {children}\n    </MemoryRouter>\n  );\n}\n\ninterface ListItemLinkProps {\n  icon?: React.ReactElement<unknown>;\n  primary: string;\n  to: string;\n}\n\nfunction ListItemLink(props: ListItemLinkProps) {\n  const { icon, primary, to } = props;\n\n  return (\n    <ListItemButton component={Link} to={to}>\n      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}\n      <ListItemText primary={primary} />\n    </ListItemButton>\n  );\n}\n\nfunction Content() {\n  const location = useLocation();\n  return (\n    <Typography variant=\"body2\" sx={{ color: 'text.secondary', pb: 2 }}>\n      Current route: {location.pathname}\n    </Typography>\n  );\n}\n\nexport default function ListRouter() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Router>\n      <Box sx={{ width: 360 }}>\n        <Routes>\n          <Route path=\"*\" element={<Content />} />\n        </Routes>\n\n        <Paper elevation={0}>\n          <List aria-label=\"main mailbox folders\">\n            <ListItem disablePadding>\n              <ListItemLink to=\"/inbox\" primary=\"Inbox\" icon={<InboxIcon />} />\n            </ListItem>\n            <ListItem disablePadding>\n              <ListItemLink to=\"/drafts\" primary=\"Drafts\" icon={<DraftsIcon />} />\n            </ListItem>\n          </List>\n          <Divider />\n          <List aria-label=\"secondary mailbox folders\">\n            <ListItem disablePadding>\n              <ListItemLink to=\"/trash\" primary=\"Trash\" />\n            </ListItem>\n            <ListItem disablePadding>\n              <ListItemLink to=\"/spam\" primary=\"Spam\" />\n            </ListItem>\n          </List>\n        </Paper>\n      </Box>\n    </Router>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 91,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport Box from '@mui/material/Box';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport Paper from '@mui/material/Paper';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\nimport Typography from '@mui/material/Typography';\nimport {\n  Link,\n  Route,\n  Routes,\n  MemoryRouter,\n  useLocation,\n  StaticRouter,\n} from 'react-router';\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/drafts\">{children}</StaticRouter>;\n  }\n\n  return (\n    <MemoryRouter initialEntries={['/drafts']} initialIndex={0}>\n      {children}\n    </MemoryRouter>\n  );\n}\n\ninterface ListItemLinkProps {\n  icon?: React.ReactElement<unknown>;\n  primary: string;\n  to: string;\n}\n\nfunction ListItemLink(props: ListItemLinkProps) {\n  const { icon, primary, to } = props;\n\n  return (\n    <ListItemButton component={Link} to={to}>\n      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}\n      <ListItemText primary={primary} />\n    </ListItemButton>\n  );\n}\n\nfunction Content() {\n  const location = useLocation();\n  return (\n    <Typography variant=\"body2\" sx={{ color: 'text.secondary', pb: 2 }}>\n      Current route: {location.pathname}\n    </Typography>\n  );\n}\n\nexport default function ListRouter() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "    <Router>\n      <Box sx={{ width: 360 }}>\n        <Routes>\n          <Route path=\"*\" element={<Content />} />\n        </Routes>\n\n        <Paper elevation={0}>\n          <List aria-label=\"main mailbox folders\">\n            <ListItem disablePadding>\n              <ListItemLink to=\"/inbox\" primary=\"Inbox\" icon={<InboxIcon />} />\n            </ListItem>\n            <ListItem disablePadding>\n              <ListItemLink to=\"/drafts\" primary=\"Drafts\" icon={<DraftsIcon />} />\n            </ListItem>\n          </List>\n          <Divider />\n          <List aria-label=\"secondary mailbox folders\">\n            <ListItem disablePadding>\n              <ListItemLink to=\"/trash\" primary=\"Trash\" />\n            </ListItem>\n            <ListItem disablePadding>\n              <ListItemLink to=\"/spam\" primary=\"Spam\" />\n            </ListItem>\n          </List>\n        </Paper>\n      </Box>\n    </Router>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 91,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/Box",
      "@mui/material/ListItemButton",
      "@mui/material/Paper",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/Divider",
      "@mui/icons-material/Inbox",
      "@mui/icons-material/Drafts",
      "@mui/material/Typography",
      "react-router"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
